"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrl = void 0;
const vue_1 = require("vue");
function useUrl() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const createCotizationUrl = (props) => {
        return `${window.location.origin}/${props.webpage}/modelos/formulario-cotizacion-session/${Number(props.isIframe)}/${props.uuid}?${props.hasTable ? 'hasTable=1' : 'hasTable=0'}`;
    };
    const createPreAutorizacionURL = (props) => {
        return `${window.location.origin}/${props.webpage}/banorte/pre-autorizacion/${props.uuid}/${props.iframe ? 1 : 0}`;
    };
    return (0, vue_1.reactive)({ url, params, createCotizationUrl, createPreAutorizacionURL });
}
exports.useUrl = useUrl;
